<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <label class="col-form-label text-primary">Año:</label>
                </div>
                <div class="col-auto">
                    <select @change="Lista();" v-model="Filtro.Anio" class="form-select form-control-search">
                        <!-- <option value="2023">2023-TESTING</option> -->
                        <option v-for="(item,index) in FiltroAnios" :key="index" :value="item">{{item}}</option>
                    </select>
                </div>
            </template>
            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <div class="container-fluid">
                            <div class="form-group row mt-3">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                    <div class="form-group row">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <h5>Flujo de efectivo</h5>
                                            </div>
                                            <hr class="horizontal dark">
                                        </div>
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <apexchart :height="GraficaFlujoEfectivo.chartOptions.chart.height" :type="GraficaFlujoEfectivo.chartOptions.chart.type" :options="GraficaFlujoEfectivo.chartOptions" :series="GraficaFlujoEfectivo.series"></apexchart>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-5">
                                    <div class="form-group row">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <h5>Documentos emitidos</h5>
                                                <div class="row">
                                                    <div class="col-auto">
                                                        <label class="col-form-label text-primary">Mes:</label>
                                                    </div>
                                                    <div class="col-auto">
                                                        <select @change="GetDataDocEmitidos();" v-model="FiltrosMes.Documentos" class="form-select form-control-search">
                                                            <option v-for="(item,index) in FiltroMeses" :key="index" :value="item.Mes">{{item.Nombre}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr class="horizontal dark">
                                        </div>
                                        <CLoader :pConfigLoad="ConfigLoadDocs">
                                            <template slot="BodyFormLoad">
                                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                    <apexchart :height="GraficaDocumentosEmitidos.chartOptions.chart.height" :type="GraficaDocumentosEmitidos.chartOptions.chart.type" :options="GraficaDocumentosEmitidos.chartOptions" :series="GraficaDocumentosEmitidos.series"></apexchart>
                                                </div>
                                            </template>
                                        </CLoader>
                                    </div>
                                </div>
            
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                    <div class="form-group row">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <h5>Cuentas</h5>
                                                <div class="row">
                                                    <div class="col-auto">
                                                        <label class="col-form-label text-primary">Mes:</label>
                                                    </div>
                                                    <div class="col-auto">
                                                        <select @change="GetDataCuentas();" v-model="FiltrosMes.Cuentas" class="form-select form-control-search">
                                                            <option v-for="(item,index) in FiltroMeses" :key="index" :value="item.Mes">{{item.Nombre}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr class="horizontal dark">
                                        </div>
                                        <CLoader :pConfigLoad="ConfigLoadCuentas">
                                            <template slot="BodyFormLoad">
                                                <div class="form-group row">
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                                        <div class="card text-white bg-success h-100">
                                                            <div class="card-body pb-0">
                                                                <div class="card-body-icon">
                                                                    <i class="far fa-hand-holding-usd"></i>
                                                                </div>
                                                                <h5 class="text-white">
                                                                    Cuentas por cobrar
                                                                </h5>
                                                                <span class="fw-bold text-center fs-5">{{ $formatNumber(DataCuentas.CobrarMonto,'$') }}</span>
                                                            </div>
                                                            <div class="card-footer clearfix small z-index-1">
                                                                <span style="float:left;font-size:16px;">Total:<div class="circNum px-2 d-inline ms-2">{{ DataCuentas.CobrarTotales }}</div></span>
                                                                <span class="cursor-pointer" style="float:right;">
                                                                    <span @click="IrACuentasCobrar()">Ver detalles <i class="far fa-chevron-right ms-1"></i></span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                                        <div class="card text-white bg-danger h-100">
                                                            <div class="card-body pb-0">
                                                                <div class="card-body-icon">
                                                                    <i class="far fa-donate"></i>
                                                                </div>
                                                                <h5 class="text-white">
                                                                    Cuentas por pagar
                                                                </h5>
                                                                <span class="fw-bold text-center fs-5">{{ $formatNumber(DataCuentas.PagarMonto,'$') }}</span>
                                                            </div>
                                                            <div class="card-footer clearfix small z-index-1">
                                                                <span style="float:left;font-size:16px;">Total:<div class="circNum px-2 d-inline ms-2">{{ DataCuentas.PagarTotales }}</div></span>
                                                                <span class="cursor-pointer" style="float:right;">
                                                                    <span @click="IrACuentasPagar()">Ver detalles <i class="far fa-chevron-right ms-1"></i></span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </CLoader>
                                    </div>
                                </div>
            
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                    <div class="form-group row">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <h5>Facturas generadas</h5>
                                                <div class="row">
                                                    <div class="col-auto">
                                                        <label class="col-form-label text-primary">Mes:</label>
                                                    </div>
                                                    <div class="col-auto">
                                                        <select @change="GetDataFacturas();" v-model="FiltrosMes.Facturas" class="form-select form-control-search">
                                                            <option v-for="(item,index) in FiltroMeses" :key="index" :value="item.Mes">{{item.Nombre}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr class="horizontal dark">
                                        </div>
                                        <CLoader :pConfigLoad="ConfigLoadFact">
                                            <template slot="BodyFormLoad">
                                                <div class="form-group row">
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                                        <div class="card text-white bg-info h-100">
                                                            <div class="card-body">
                                                                <div class="card-body-icon">
                                                                    <i class="far fa-file-invoice-dollar"></i>
                                                                </div>
                                                                <h5 class="text-white">
                                                                    Facturas Emitidas
                                                                </h5>
                                                            </div>
                                                            <div class="card-footer clearfix small z-index-1 cursor-pointer">
                                                                <span style="float:left;font-size:15px;">Total:</span>
                                                                <span style="float:right;">
                                                                    <div class="circNum px-3">
                                                                        <p>{{ DataFacturas.Emitidas }}</p>
                                                                    </div>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                                        <div class="card text-white bg-success h-100">
                                                            <div class="card-body">
                                                                <div class="card-body-icon">
                                                                    <i class="far fa-file-invoice-dollar"></i>
                                                                </div>
                                                                <h5 class="text-white">
                                                                    Facturas Cobradas
                                                                </h5>
                                                            </div>
                                                            <div class="card-footer clearfix small z-index-1 cursor-pointer">
                                                                <span style="float:left;font-size:15px;">Total:</span>
                                                                <span style="float:right;">
                                                                    <div class="circNum px-3">
                                                                        <p>{{ DataFacturas.Cobradas }}</p>
                                                                    </div>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                                        <div class="card text-white bg-danger h-100">
                                                            <div class="card-body">
                                                                <div class="card-body-icon">
                                                                    <i class="far fa-file-invoice-dollar"></i>
                                                                </div>
                                                                <h5 class="text-white">
                                                                    Facturas Canceladas
                                                                </h5>
                                                            </div>
                                                            <div class="card-footer clearfix small z-index-1 cursor-pointer">
                                                                <span style="float:left;font-size:15px;">Total:</span>
                                                                <span style="float:right;">
                                                                    <div class="circNum px-3">
                                                                        <p>{{ DataFacturas.Canceladas }}</p>
                                                                    </div>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </CLoader>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </CLoader>
			</template>
		</CList>
	</div>
</template>

<script>

import moment, { relativeTimeThreshold } from 'moment';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionConfiSseguimiento';

export default {
    name: 'ListaConfiSseguimiento',
    props: ['sFiltros','pOrigen'],
    components: {},
    data() {
        return {
            ConfigList:{
                Title: 'Gráficas de Cuentas',
                IsModal: true,
                ShowSearch: false,
                ShowEntradas: false,
                // ShowYear: true,
                TypeBody:'Form',
                ShowPaginador:false,
                BtnNewShow:false,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: '',
            },
            ConfigLoad:{
                ShowLoader:false,
                ClassLoad: false,
            },
            ConfigLoadDocs:{
                ShowLoader:false,
                ClassLoad: false,
            },
            ConfigLoadCuentas:{
                ShowLoader:false,
                ClassLoad: false,
            },
            ConfigLoadFact:{
                ShowLoader:false,
                ClassLoad: false,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                Anio: moment(new Date()).format('YYYY'),
            },
            GraficaFlujoEfectivo:{
                chartOptions:{
                    chart:{
                        type:'bar',
                        height:"350",
                    },
                    title:{
                        text:'Flujo de Efectivo',
                        align:"center"
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '55%',
                            endingShape: 'rounded'
                        },
                    },
                    xaxis: {
                        categories: ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],
                    },
                    yaxis:{
                        labels:{
                            formatter:(num)=>{
                                let fixed = 0;
                                if (num === null) { return null; } // terminate early
                                if (num === 0) { return '0'; } // terminate early
                                fixed = (!fixed || fixed < 0) ? 0 : fixed; // number of decimal places to show
                                const b = (num).toPrecision(2).split("e"), // get power
                                    k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
                                    c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed), // divide by power
                                    d = c < 0 ? c : Math.abs(c), // enforce -0 is 0
                                    e = d + ['', ' K', ' M', ' B', ' T'][k]; // append power
                                return e;
                            }
                        },
                        title:{
                            text:'Importe $'
                        }
                    },
                    dataLabels:{
                        enabled:false
                    },
                    tooltip: {
                        y: {
                            formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
                                let formatValue = Configs.formatNumber(value,'$');
                                return formatValue;
                            }
                        }
                    },
                    colors: ['#5EB160', '#f5365c'],
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                },
                series:[]
            },
            GraficaDocumentosEmitidos:{
                chartOptions:{
                    chart:{
                        type:'donut',
                        height:"350",
                    },
                    labels: ['Facturas', 'Notas Crédito', 'Notas venta', 'Sin Registro'],
                    colors: ['#5e72e4', '#51d625','#ffd92f', '#ff7300'],
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    tooltip: {
                        y:{ formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
                            // Le da formato al value del tooltip de series menos a 'Sin Registro' en el cual mostrará 0
                            if(seriesIndex==3){
                                return 0;
                            } else {
                                let formatValue = Configs.formatNumber(value,'$');
                                return formatValue;
                            }
                        
                        }}
                    },
                },
                series:[0,0,0,100]
            },
            DataFacturas:{
                Emitidas:0,
                Cobradas:0,
                Canceladas:0,
            },
            DataCuentas:{
                CobrarMonto:0,
                CobrarTotales:0,
                PagarMonto:0,
                PagarTotales:0,
            },
            FiltrosMes:{
                Documentos:'',
                Cuentas:'',
                Facturas:'',
            },
            FiltroMeses: [
                {Mes:'',Nombre:'Todos'},
                {Mes:'01',Nombre:'Enero'},
                {Mes:'02',Nombre:'Febrero'},
                {Mes:'03',Nombre:'Marzo'},
                {Mes:'04',Nombre:'Abril'},
                {Mes:'05',Nombre:'Mayo'},
                {Mes:'06',Nombre:'Junio'},
                {Mes:'07',Nombre:'Julio'},
                {Mes:'08',Nombre:'Agosto'},
                {Mes:'09',Nombre:'Septiembre'},
                {Mes:'10',Nombre:'Octubre'},
                {Mes:'11',Nombre:'Noviembre'},
                {Mes:'12',Nombre:'Diciembre'},
            ],
            segurity: {},
            obj: {},
            ListaArrayRows: [],        
            FiltroAnios: [], 
            CambioAnio:false, // Helper para no cargar todos los loaders cuando cambia el año
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
		async Lista()
        {
            this.CambioAnio = true,
            this.ConfigLoad.ShowLoader = true;

            await this.GetDataFlujoEfectivo();
            await this.GetDataDocEmitidos();
            await this.GetDataCuentas();
            await this.GetDataFacturas();

            this.ConfigLoad.ShowLoader = false;
            this.CambioAnio = false;
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus', params:{}});
        },
        IrACuentasCobrar(){
            this.$router.push({name:'cuentaporcobrar', params:{pOrigen:'GraficasCuentas'}});
        },
        IrACuentasPagar(){
            this.$router.push({name:'cuentaporpagar', params:{pOrigen:'GraficasCuentas'}});
        },
        async GetDataDocEmitidos(){
            if(!this.CambioAnio){
                this.ConfigLoadDocs.ShowLoader = true;
            }

            await this.$http.get('graficasCuentasDocumentos',{params:{
                Anio: this.Filtro.Anio,
                Mes:this.FiltrosMes.Documentos,
            }}).then((res) => {
                this.GraficaDocumentosEmitidos.series = res.data.data;
            }).finally(() => {
                this.ConfigLoadDocs.ShowLoader = false;
            })
        },
        async GetDataFlujoEfectivo(){
            if(!this.CambioAnio){
                this.ConfigLoadCuentas.ShowLoader = true;
            }

            await this.$http.get('graficasCuentasEfectivo',{params:{
                Anio: this.Filtro.Anio,
            }}).then((res) => {
                this.GraficaFlujoEfectivo.series = res.data.data;
            }).finally(() => {
                this.ConfigLoadCuentas.ShowLoader = false;
            })
        },
        async GetDataCuentas(){
            if(!this.CambioAnio){
                this.ConfigLoadCuentas.ShowLoader = true;
            }

            await this.$http.get('graficasCuentasCuentas',{params:{
                Anio: this.Filtro.Anio,
                Mes: this.FiltrosMes.Cuentas,
            }}).then((res) => {
                this.DataCuentas = res.data.data;
            }).finally(() => {
                this.ConfigLoadCuentas.ShowLoader = false;
            })
        },
        async GetDataFacturas(){
            if(!this.CambioAnio){
                this.ConfigLoadFact.ShowLoader = true;
            }
            await this.$http.get('graficasCuentasFacturas',{params:{
                Anio: this.Filtro.Anio,
                Mes: this.FiltrosMes.Facturas,
            }}).then((res) => {
                this.DataFacturas = res.data.data;
            }).finally(() => {
                this.ConfigLoadFact.ShowLoader = false;
            })
        },
        SetAnios(){
            let AnioIncial='2024';
            let AnioSig = moment(new Date()).format('YYYY');
            for(let a = AnioIncial; a <= AnioSig; a++){
                this.FiltroAnios.push(a);
            };
        },
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.SetAnios();
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
